import { createStore, applyMiddleware, compose } from 'redux'

import reducers from './reducers'

const middlewares = []

if (process.env.REACT_APP_REDUX_LOG === 'true') {
  const { logger } = require('redux-logger')
  middlewares.push(logger)
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const enhancers = composeEnhancers(applyMiddleware(...middlewares))
const store = createStore(reducers, enhancers)

export default store
